interface Props {
  location: {
    lat: number;
    lon: number;
  };
}

export const orderNorthToSouth = (data: Props[] | undefined): any[] | undefined => {
  if (data === undefined) {
    return data;
  }
  const sortedData = data.slice().sort((a, b) => b.location.lat - a.location.lat);
  return sortedData;
};

export const orderSouthToNorth = (data: Props[] | undefined): any[] | undefined => {
  if (data === undefined) {
    return data;
  }
  const sortedData = data.slice().sort((a, b) => a.location.lat - b.location.lat);
  return sortedData;
};
